import { useQuery } from '@hooks/reactQuery';

import { getOptionsCellsOran } from '@api/kpi';

import { IGroupSelectOptions } from '@components/common/GroupSelect/GroupSelect.types';

import { ETechnologiesValues, EUserRoles, EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { OPTIONS_T_5G_ORAN } from '@constants/queryKeys';

interface IUseQueryOptionsCellsOranReturned {
	options5GOran?: IGroupSelectOptions[];
	isLoadingOptions5GOran: boolean;
}

interface IUseQueryOptionsCellsOranProps {
	isKpiView: boolean;
	availableVendors: string[];
}

export const useQueryOptionsCellsOran = (props: IUseQueryOptionsCellsOranProps): IUseQueryOptionsCellsOranReturned => {
	const { isKpiView, availableVendors } = props;
	const isOranVendor = availableVendors.includes(EVendorsValues.oran);

	const {
		data: options5GOran,
		isInitialLoading: isLoadingOptions5GOran,
	} = useQuery({
		queryKey: [OPTIONS_T_5G_ORAN],
		queryFn: () => getOptionsCellsOran({
			technology: ETechnologiesValues.T_5G,
			vendor: EVendorsValues.oran,
		}),
		select: (data) => {
			return data.map(input => ({
				category: {
					name: input.classifier.name,
					title: input.classifier.title,
				},
				items: input.categoryGroups.map(group => ({
					category: {
						name: group.category.name,
						title: group.category.title,
					},
					items: group.items.map(item => ({
						id: item.id,
						title: item.title,
						isAbsent: item.isAbsent,
					})),
				})),
			}));
		},
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, isOranVendor],
		...refetchOptions,
	});

	return {
		options5GOran,
		isLoadingOptions5GOran,
	};
};
